module.exports = __webpack_public_path__ + "img/logo-cg.a68b84d3.svg";